export const SITE_URL = "https://brandintegrated.com";
export const SITE_NAME = "Brand Integrated";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/bi-logo.jpg`;
export const DEFAULT_DESCRIPTION =
  "Brand Integrated architects legacies. We bridge strategy and execution for visionaries ready to scale, providing holistic expertise in brand strategy, growth, and digital transformation.";

export function setRobotsMeta(content) {
  if (typeof document === "undefined") return;
  let meta = document.querySelector('meta[name="robots"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}
